// extracted by mini-css-extract-plugin
module.exports = {"noop":"AddressCard_noop__QxH4M","cardTitle":"AddressCard_cardTitle__KNt30","flexEnd":"AddressCard_flexEnd__31Dhf"};